module.exports = __webpack_public_path__ + "img/feedback.1e813533.png";